import React from 'react'
import { Card, Drawer, Form, Icon, notification, Button, Tooltip, Input, Row, Col } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import { connect } from 'react-redux'
import TextArea from 'antd/lib/input/TextArea'
import Request, { API_URL, LAPI_URL } from '../../request'
import moment from 'moment'
import Moment from "moment";

@Form.create()

class AddTaskForm extends React.Component {
    state = {
        visible: true,
        showAssignto: true,
        disableBTN: false,
        assignId: ''
    }

    onClose = () => {
        this.setState({
            visible: false
        })
        let $this = this
        setTimeout(() => {
            $this.props.onClose()
        }, 400)
    }
    saveTask = (e) => {
        const { dispatch, form } = this.props
        e.preventDefault()
        this.setState({ disableBTN: true });
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                if (this.state.assignId) {
                    values.assignId = this.state.assignId;
                }
                let x = await Request.addTask(values);
                if (!x.error) {
                    notification.success({
                        message: 'Task Added successfully'
                    })
                    form.resetFields();
                    this.onClose();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
                this.setState({ disableBTN: false });
            }
        })
    }

    async componentDidMount() {
        const { taskDate, form } = this.props;
        setTimeout(function () {
            form.setFieldsValue({ startDate: Moment(taskDate), startTime: moment().format('HH:mm'), dueDate: moment(taskDate), priority: 'High' });
        }, 1000);
    }

    render() {
        const { taskDate, allUsers } = this.props;
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props;

        const { disableBTN } = this.state;

        const inputTypes = {
            fields: [
                // {
                //     label: 'Assign Task To',
                //     key: 'taskType',
                //     required: true,
                //     type: 'select',
                //     disabled: false,
                //     allowClear: true,
                //     options: ['AssignTo', 'Self'],
                //     onChange: taskType => {
                //         if(taskType == 'AssignTo') {
                //             this.setState({showAssignto: false})
                //         } else {
                //             this.setState({showAssignto: true}) 
                //             let localUser = JSON.parse(localStorage.getItem("user"));  
                //             this.setState({assignId: localUser._id});                   
                //         }        
                //         setFieldsValue({taskType: taskType && taskType.toString()})
                //     }
                // },
                {
                    label: 'Assign Task To',
                    key: 'assignId',
                    type: 'select',
                    disabled: false,
                    allowClear: true,
                    showSearch: true,
                    required: true,
                    // hidden: this.state.showAssignto,
                    // required: this.state.showAssignto ? false : true,
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.name,
                    options: allUsers ? allUsers : {},
                    onChange: assignId => {
                        setFieldsValue({ assignId: assignId && assignId.toString() })
                    }
                },
                {
                    label: 'Task Title',
                    key: 'taskTitle',
                    required: true
                },
                {
                    label: 'Description',
                    key: 'description',
                    required: true,
                    type: 'textArea',
                    rows: 10
                },
                {
                    label: 'Start Date',
                    key: 'startDate',
                    required: true,
                    type: 'date',
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'Start Time',
                    key: 'startTime',
                    required: true,
                    type: 'time',
                    defaultValue: moment().format('HH:mm'),
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day')),
                    }
                },
                {
                    label: 'Due Date',
                    key: 'dueDate',
                    required: true,
                    type: 'date',
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day')),
                    }
                },
                {
                    label: 'Timeline',
                    key: 'deadlineTime',
                    required: true,
                    type: 'time',
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day')),
                    }
                },
                {
                    label: 'Priority',
                    key: 'priority',
                    required: true,
                    type: 'select',
                    disabled: false,
                    allowClear: true,
                    options: ['High', 'Low', 'Normal'],
                    onChange: priority => {
                        setFieldsValue({ priority: priority && priority.toString() })
                    }
                },

            ]
        };
        return (
            <Drawer
                title={
                    <div>
                        {'Add New Task'} {' '}
                        {
                            disableBTN == false ?
                                <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                                    <Icon type={'close'} />
                                </a>
                                : null
                        }
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.saveTask} style={{ marginTop: 8 }}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={inputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Button
                            type=""
                            htmlType="submit"
                            style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                            }}
                            disabled={disableBTN}
                            loading={this.props.loading}>
                            ADD
                        </Button>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddTaskForm)